import { partnersApi } from './index'

export default partnersApi.middleware
